import { render } from "./OrderCustomFieldsIndexPage.vue?vue&type=template&id=283975d3"
import script from "./OrderCustomFieldsIndexPage.vue?vue&type=script&lang=js"
export * from "./OrderCustomFieldsIndexPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__